module.exports = __webpack_public_path__ + "static/bible-plain-0748f186af257b246affeee71c348a22.jpg";